export const LANDING_PREVIEW_BREAKPOINTS = Object.freeze({
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
});

export const LANDING_PREVIEW_DEVICES = Object.freeze({
  desktop: Object.freeze({
    id: "desktop",
    label: "Escritorio",
    width: 1280,
    height: 800,
    breakpoint: "lg",
  }),
  tablet: Object.freeze({
    id: "tablet",
    label: "Tablet",
    width: 768,
    height: 1024,
    breakpoint: "sm",
  }),
  mobile: Object.freeze({
    id: "mobile",
    label: "Celular",
    width: 390,
    height: 844,
    breakpoint: "xs",
  }),
});

const BREAKPOINT_ORDER = Object.freeze(["xs", "sm", "md", "lg", "xl"]);

export function normalizeLandingPreviewDevice(value) {
  const key = String(value || "").trim().toLowerCase();
  return LANDING_PREVIEW_DEVICES[key] ? key : "desktop";
}

export function getLandingPreviewDevice(value) {
  return LANDING_PREVIEW_DEVICES[normalizeLandingPreviewDevice(value)];
}

export function getLandingPreviewBreakpoint(value) {
  const width = typeof value === "number"
    ? value
    : getLandingPreviewDevice(value).width;
  let resolved = "xs";
  for (const breakpoint of BREAKPOINT_ORDER) {
    if (width >= LANDING_PREVIEW_BREAKPOINTS[breakpoint]) resolved = breakpoint;
  }
  return resolved;
}

function responsivePriorityForWidth(width) {
  const activeBreakpoint = getLandingPreviewBreakpoint(width);
  const activeIndex = BREAKPOINT_ORDER.indexOf(activeBreakpoint);
  return BREAKPOINT_ORDER.slice(0, activeIndex + 1).reverse();
}

export function resolveLandingPreviewResponsiveValue(device, values, fallback) {
  if (values === null || values === undefined || typeof values !== "object" || Array.isArray(values)) {
    return values === undefined ? fallback : values;
  }

  const previewDevice = getLandingPreviewDevice(device);
  const priority = responsivePriorityForWidth(previewDevice.width);
  for (const breakpoint of priority) {
    if (Object.prototype.hasOwnProperty.call(values, breakpoint)) return values[breakpoint];
  }

  return fallback;
}

export function getLandingPreviewHeroMinHeight(device) {
  const previewDevice = getLandingPreviewDevice(device);
  const breakpoint = getLandingPreviewBreakpoint(previewDevice.width);
  if (breakpoint === "xs") {
    return Math.round(Math.min(previewDevice.height * 0.88, 720));
  }
  return Math.round(Math.max(previewDevice.height, 620));
}
